import React, { ReactNode } from 'react';
import styled from '@emotion/styled';

interface FormProps {
  /**
   * The react child to render
   */
  children: ReactNode;
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
  /**
   * Disbles HTML's default form submit on 'Enter' key press
   */
  disableEnterKeypress?: string;
  /**
   * The submit function to pass down into the form
   */
  onSubmit: any;
}

const Form = ({
  children,
  className,
  disableEnterKeypress,
  onSubmit,
}: FormProps) => {
  return (
    <form
      className={className}
      onKeyPress={(e) => {
        disableEnterKeypress && e.key === 'Enter' && e.preventDefault();
      }}
      onSubmit={onSubmit}>
      {children}
    </form>
  );
};

const StyledForm = styled((props: any) => <Form {...props} />)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export default StyledForm;
